import { render, staticRenderFns } from "./StationDefectsList.vue?vue&type=template&id=8b3e17b4"
import script from "./StationDefectsList.vue?vue&type=script&lang=ts"
export * from "./StationDefectsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports